export const FoldTypeSetting = {
  DISABLED: 0,
  ENABLED: 1,
};

export const RoleType = {
  NOSET: 0,
  MANAGER: 1,
  LEADER: 2,
  WASH_FOLD: 3,
  PICKUP_DELIVERY: 4,
};

export const Role = {
  ADMIN: 100,
  STAFF: 200,
  GENERAL: 900,
};

// 請求書CSVの売上まとめ番号でinvoice_idを8桁ゼロ埋めするため、8桁に収まる値を上限とする
export const INVOICE_ID_MAX = 99999999;
